module.exports = __webpack_public_path__ + "img/modal_bg.27f05677.png";